import { sendErrorEvent } from '@trello/error-reporting';
import { ProductFeatures } from '@trello/product-features';

import { useUpgradePromptOrganizationDataQuery } from './UpgradePromptOrganizationDataQuery.generated';

/*
 * Finds product information based on orgId
 */
export const useProductData = (
  orgId: string,
  options: { skip: boolean } = { skip: false },
) => {
  const { data, error, loading } = useUpgradePromptOrganizationDataQuery({
    variables: { orgId },
    skip: !orgId || options.skip,
    waitOn: ['MemberHeader', 'MemberBoards'],
  });
  const productCode = data?.organization?.products?.[0];
  const productFeatures = data?.organization?.premiumFeatures;
  const productName = ProductFeatures.getProductName(productCode);
  const productInterval = ProductFeatures.getInterval(productCode);

  const isStandard = ProductFeatures.isStandardProduct(productCode);
  const isPremium = ProductFeatures.isPremiumProduct(productCode);

  const isEnterprise = ProductFeatures.isEnterpriseProduct(productCode);
  const isFree = !isStandard && !isPremium && !isEnterprise;

  if (error)
    sendErrorEvent(error, {
      tags: { ownershipArea: 'trello-web-eng' },
    });

  return {
    productCode,
    productName,
    productInterval,
    productFeatures,
    isFree,
    isStandard,
    isPremium,
    isEnterprise,
    loading,
  };
};
